import { defineAction } from '~/prix'
import { z } from 'zod'
import trainingFetchAction from './trainingFetch.action.json' with { type: 'json' }
import { trainingObject } from '../trainingObject'

const trainingFetchDefinition = defineAction({
  ...trainingFetchAction,

  input: z.object({ id: trainingObject.shape.id, includeDeleted: z.boolean().nullish() }),
  output: trainingObject,
})

export default trainingFetchDefinition
